<template>
  <v-menu
    v-model="showMenu"
    offset-y
    bottom
    nudgeBottom="10"
    :min-width="240"
    :max-width="300"
    transition="scale-transition"
    content-class="records-time-range__content"
    :close-on-content-click="false"
  >
    <v-btn
      class="records-time-range__btn"
      :class="{ selected: selected }"
      depressed
      color="grey lighten-3"
      slot="activator"
    >
      <SvgIcon class="tag-icon" height="20" width="20" icon="Time" />
      <span v-if="activatorLabel">{{ activatorLabel }}</span>
      <span v-else>{{ $t('date_range_picker.label') }}</span>
    </v-btn>

    <ATimePicker
      :allowAdvancedOptions="true"
      :allowAllOption="false"
      :allowCustomOption="true"
      :maxDaysRange="maxDaysRange"
      :initOption="initOption"
      :initFromDate="initFromDate"
      :initToDate="initToDate"
      @onChange="handleChange"
      @onClose="showMenu = false"
    />
  </v-menu>
</template>

<script>
import ATimePicker from '@/components/ahamove/ATimePicker'

export default {
  name: 'RecordsTimeRange',
  props: {
    activatorLabel: {
      type: String
    },
    initOption: {
      type: String
    },
    maxDaysRange: {
      type: Number,
      default: 31
    },
    initFromDate: {
      type: Number
    },
    initToDate: {
      type: Number
    },
    onChange: {
      type: Function
    }
  },
  components: {
    ATimePicker
  },
  computed: {
    selected() {
      return this.initOption && this.initOption !== 'ALL'
    }
  },
  data() {
    return {
      showMenu: false
    }
  },
  methods: {
    handleChange(payload) {
      this.showMenu = false
      this.$emit('onChange', payload)
    }
  }
}
</script>

<i18n src="@/locales2/share/datetime.json"></i18n>

<style lang="scss" scoped>
.records-time-range__btn {
  border-radius: 41px;
  text-transform: none;
  font-weight: normal;

  .tag-icon {
    margin-right: 4px;
  }
}
</style>

<style lang="scss">
.records-time-range__content {
  border-radius: 8px;
}

.records-time-range__btn {
  &.selected {
    background-color: #7a8189 !important;
    border-color: #7a8189 !important;
    color: #fff;

    .tag-icon {
      svg {
        fill: #7a8189;

        path {
          fill: #fff;
        }
      }
    }
  }
}
</style>
